// extracted by mini-css-extract-plugin
export default {"dialog":"OTr-","size-medium":"_3v2o","size-large":"_1VTi","size-xlarge":"mEyq","size-xxlarge":"_3STh","size-full":"_1t1n","size-fill":"_1Qrs"};